import { formatFileSize } from "shared/utils";
import { getCookie } from "shared/utils/cookies";
import { Transforms } from "slate";

export async function uploadImageAndInsert(editor, file, onUpdateAttachment, lookupId, workspaceId, commentId, setLoading, folderId) {
  const formData = new FormData();
  formData.append("files", file);
  let uploadUrl = "";
  if (commentId) {
    formData.append("module", workspaceId ? "comments" : "files");
    formData.append("lookupId", commentId);
    formData.append("folderId", lookupId);
    if(workspaceId){
      formData.append("service", workspaceId);
    }
    uploadUrl = `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`;
  } else if (workspaceId && !commentId) {
    formData.append("module", "taskplanner");
    formData.append("lookupId", lookupId);
    formData.append("service", workspaceId);
    uploadUrl = `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`;
  } else {
    uploadUrl = `${process.env.REACT_APP_PROXY_HOST}/api/v1/file/upload/content/files`;
  }
  if(folderId){
    formData.append("folderId", folderId);
  }

  setLoading(true);

  try {
    const res = await fetch(uploadUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getCookie("accessToken")}`
      },
      body: formData
    });

    const data = await res.json();
    const uploadData = Array.isArray(data) ? data[0] : data;

    const url = uploadData?.url || uploadData;
    const fileId = uploadData?.fileId || file.uid;

    if (!url) throw new Error("No URL found in upload response");

    const imageNode = {
      type: "image",
      url,
      fileId,
      name: file.name,
      align: "left",
      width: 300,
      height: 200,
      children: [{ text: "" }]
    };
    setLoading(false);
    Transforms.insertNodes(editor, {
      type: "paragraph",
      children: [{ text: "" }]
    });
    Transforms.insertNodes(editor, imageNode);
    Transforms.insertNodes(editor, {
      type: "paragraph",
      children: [{ text: "" }]
    });

    const fileObj = {
      name: file.name,
      size: commentId ? file.size : formatFileSize(file.size),
      type: file.type,
      fileId,
      url: url,
      uid: fileId,
      lastModifiedDate: file.lastModifiedDate
    };
    onUpdateAttachment?.([fileObj], 'rc');

  } catch (error) {
    console.error("Upload failed:", error);
  }
}